import React from 'react';
import './FooterComponent.scss';

import I18N from "../js/i18n";

class FooterComponent extends React.Component {
  constructor(props) {
    super(props);
    this.prevScrollPos = window.pageYOffset;
    this.navRef = React.createRef();
    this.state = {
      navbarVisible: true,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
  
    if (currentScrollPos > 0) {
      // Scrolling down
      this.setState({ navbarVisible: false });
    } else {
      // Scrolling up
      this.setState({ navbarVisible: true });
    }
  
    this.prevScrollPos = currentScrollPos;
  };
    render() {
      const { navbarVisible } = this.state;
      const navbarClasses = `footer text-center ${navbarVisible ? 'footer-scroll-show' : 'footer-scroll-hide'}`;
        return (
          <div className={navbarClasses} ref={this.navRef}>
            <span className="small">&#169; {new Date().getFullYear()}
            {" "}
            <a href="https://agorahub.xyz" target="_blank"><I18N type="ui" path="AGORA_HUB" def="Agora Hub"/></a>. 
            {" "}
            <I18N type="ui" path="ALL_RIGHTS_RESERVED" def="All Rights Reserved"/>. v{process.env.REACT_APP_VERSION}
            </span>
          </div>
        );
    }
}

export default FooterComponent;